import React, { useState, useEffect, useContext } from 'react';
import './Sidebar.css';

import lupaMais from "../../assets/lupaMais.svg";
import lupaMenos from "../../assets/lupaMenos.svg";
import audioIcon from "../../assets/audioIcon.svg";
import notAudioIcon from "../../assets/notAudioIcon.svg";

import { TextReaderContext } from '../../context/TextReaderContext';

const FONT_STEP = 2;
const FONT_LIMIT = 4;

const INTRO_DELAY = 2000;
const INTRO_DURATION = 3000;

const Sidebar = () => {
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [fontDelta, setFontDelta] = useState(0);
    const [introVisible, setIntroVisible] = useState(false);

    const { isTextReaderEnabled, toggleTextReader } = useContext(TextReaderContext);

    useEffect(() => {
        document.documentElement.style.setProperty('--font-delta', `${fontDelta}px`);
    }, [fontDelta]);

    useEffect(() => {
        const abrir = setTimeout(() => setIntroVisible(true), INTRO_DELAY);
        const fechar = setTimeout(() => setIntroVisible(false), INTRO_DELAY + INTRO_DURATION);
        return () => {
            clearTimeout(abrir);
            clearTimeout(fechar);
        };
    }, []);

    const toggleSidebar = () => setSidebarVisible(!sidebarVisible);
    const increaseFontSize = () => setFontDelta(d => Math.min(d + FONT_STEP, FONT_LIMIT));
    const decreaseFontSize = () => setFontDelta(d => Math.max(d - FONT_STEP, -FONT_LIMIT));

    return (
        <div className="a11y-bar">
            <div
                className={`a11y-tools ${sidebarVisible ? 'is-open' : ''}`}
                id="ferramentas-acessibilidade"
            >
                <button
                    type="button"
                    className="a11y-button"
                    onClick={increaseFontSize}
                    disabled={fontDelta >= FONT_LIMIT}
                    title='Aumentar a fonte'
                    aria-label="Aumentar fonte"
                >
                    <img src={lupaMais} alt="" />
                </button>
                <button
                    type="button"
                    className="a11y-button"
                    onClick={decreaseFontSize}
                    disabled={fontDelta <= -FONT_LIMIT}
                    title='Diminuir a fonte'
                    aria-label="Diminuir fonte"
                >
                    <img src={lupaMenos} alt="" />
                </button>
                <button
                    type="button"
                    className="a11y-button"
                    onClick={toggleTextReader}
                    title={isTextReaderEnabled ? 'Pausar áudio' : 'Reproduzir áudio'}
                    aria-pressed={isTextReaderEnabled}
                    aria-label={isTextReaderEnabled ? 'Pausar leitor de tela' : 'Ativar leitor de tela'}
                >
                    <img src={isTextReaderEnabled ? audioIcon : notAudioIcon} alt="" />
                </button>
            </div>

            <button
                type="button"
                className={`a11y-button a11y-toggle ${introVisible ? 'is-intro' : ''}`}
                onClick={toggleSidebar}
                aria-expanded={sidebarVisible}
                aria-controls="ferramentas-acessibilidade"
                aria-label={`${sidebarVisible ? 'Fechar' : 'Abrir'} ferramentas de acessibilidade`}
            >
                {sidebarVisible ? (
                    <svg className="a11y-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                        <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                ) : (
                    <svg className="a11y-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 122.88" aria-hidden="true" focusable="false">
                        <path d="M61.44,0A61.46,61.46,0,1,1,18,18,61.21,61.21,0,0,1,61.44,0Zm-.39,74.18L52.1,98.91a4.94,4.94,0,0,1-2.58,2.83A5,5,0,0,1,42.7,95.5l6.24-17.28a26.3,26.3,0,0,0,1.17-4,40.64,40.64,0,0,0,.54-4.18c.24-2.53.41-5.27.54-7.9s.22-5.18.29-7.29c.09-2.63-.62-2.8-2.73-3.3l-.44-.1-18-3.39A5,5,0,0,1,27.08,46a5,5,0,0,1,5.05-7.74l19.34,3.63c.77.07,1.52.16,2.31.25a57.64,57.64,0,0,0,7.18.53A81.13,81.13,0,0,0,69.9,42c.9-.1,1.75-.21,2.6-.29l18.25-3.42A5,5,0,0,1,94.5,39a5,5,0,0,1,1.3,7,5,5,0,0,1-3.21,2.09L75.15,51.37c-.58.13-1.1.22-1.56.29-1.82.31-2.72.47-2.61,3.06.08,1.89.31,4.15.61,6.51.35,2.77.81,5.71,1.29,8.4.31,1.77.6,3.19,1,4.55s.79,2.75,1.39,4.42l6.11,16.9a5,5,0,0,1-6.82,6.24,4.94,4.94,0,0,1-2.58-2.83L63,74.23,62,72.4l-1,1.78Zm.39-53.52a8.83,8.83,0,1,1-6.24,2.59,8.79,8.79,0,0,1,6.24-2.59Zm36.35,4.43a51.42,51.42,0,1,0,15,36.35,51.27,51.27,0,0,0-15-36.35Z" fill="white"/>
                    </svg>
                )}
                <span className="a11y-tooltip-clip">
                    <span className="a11y-tooltip">Ferramentas de acessibilidade</span>
                </span>
            </button>
        </div>
    );
};

export default Sidebar;
